<div>
   @for (displayFlight of displayFlights(); track $index) {
      <section
         [class.pdf:hidden]="hiddenFlightIds() && !hiddenFlightIds().includes(displayFlight?.id)"
         class="overflow-x-auto"
      >
         <div class="text-lg pt-4 pb-2 font-semibold">
            {{ displayFlight.description }}
         </div>
         <webvis-ui-intermediate-report-grid
            (kpiFormChange)="updateUnsavedChanges()"
            [columnConfig]="columns()"
            [formDataMap]="orderKpiDataMap()"
            [intermediateReport]="intermediateReport()"
            [orders]="displayFlight.orders"
            [readonly]="readonly()"
            [reportDate]="reportDate()"
            [reportModeActive]="reportModeActive()"
            [selectedView]="selectedView()"
         ></webvis-ui-intermediate-report-grid>
      </section>
   }
</div>
